var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkAsResolved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABRklEQVR4nN2UTU4CQRCFv5DAxiERLyHewZ/GAygYMicwnIA7KFwD5Q4aFuDStYEBceNOl+oBSCePhAw9TPe44yWdTKrfvK5UvSrYd1SAGBgCCfCnkygWi1MIN8AH8ATcAsfAgU5dsWdgCbRChEtAX1meefAtZw709G8urPgYOAxIqgZM9EhuWZJA8c1HFkCTDFRUT0NxnKtvzsbHatp/MQLarouhnBECA7ylYh3gwUWey4oh4l+OktbVxy38ApGn+KnELx13kbS28ANUU7FXR4ZZma9RlZZXiUxKLE98Z4keM5psJNoFvj1sbJs8CLWpAT49ZyTTpmXgHWhQHBe7Bg1txURjH4ojrYqrPGJPi6sWKP4C3PmQS3pk4Vnzhrj3vut6jaZ6MpIzTjREkb47urPi1xREWY6wu2WmCbVnKivaO8vZY6wA0XRIQUkxm4gAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsResolved);
export default __webpack_public_path__ + "static/media/mark_as_resolved.ab5274d288d2c607857a619666602c9b.svg";
export { ForwardRef as ReactComponent };